module.exports = __webpack_public_path__ + "img/home-gzh-erw.6bb1753b.png";